import { Box, Typography } from "@mui/material";
import pic from "assets/splashpage/pro_splash_page.jpg";
import { AlertContext } from "contexts/Alert";
import {
  PRO_EMAIL_MONTHLY_LIMIT,
  SplashPage,
  SubscriptionContext,
} from "contexts/Subscription";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

import { getSource } from "utils/tracking";
import { useSubscription } from "utils/useSubscription";

import SplashPageHome from "../components/Home";

const ProPlanSplashPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const source = getSource();
  const { setAlert } = useContext(AlertContext);
  const { subscription, isProPlan } = useContext(SubscriptionContext);
  const notQualified = Boolean(isProPlan && subscription?.isSubscribed);
  const { handleCheckout } = useSubscription();

  const checkOutForSplashPage = (plan: Plans) => {
    if (notQualified) {
      setAlert(
        "You already subscribed. Please go to Settings page to manage your subscription.",
        "info",
      );
      navigate(`/${routes.home}${location.search}`, { replace: true });
    } else {
      handleCheckout(
        Plans.PRO_YEARLY,
        source || "",
        window.location.pathname,
        SplashPage.pro,
      );
    }
  };

  return (
    <SplashPageHome
      checkOutForSplashPage={checkOutForSplashPage}
      sidebarPic={pic}
      planDetails={
        <>
          <Typography variant="h2">Bento's Pro Subscription</Typography>
          <Typography variant="h6">
            Supercharge your outreach. Earn more brand deals.
          </Typography>

          <Box sx={{ mt: 6 }}>
            <Typography sx={{ mb: 2 }}>
              <strong>Why Creators Choose Pro</strong>
            </Typography>
            🟢 <strong>Pitch at scale </strong> Send up to{" "}
            {PRO_EMAIL_MONTHLY_LIMIT} targeted pitches every month <br />
            🟢 <strong>Smart brand targeting </strong> Use exclusive filters to
            reach the right brands (e.g "Brands that work with UGC creators")
            <br />
            🟢 <strong>Reply Score Insights </strong>See which brands are most
            likely to respond before you hit send
            <br />
            🟢 <strong>Fresh, Personalized Recommendations </strong>Get updated
            brand matches every month, tailored to your niche <br />
            🟢 <strong>Cancel Anytime </strong>No contracts, no lock-ins. Just
            total flexibility <br />
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography sx={{ mb: 2 }}>
              <strong>The Results</strong>
            </Typography>
            <Typography>
              🚀 Pro members are{" "}
              <Box sx={{ color: "success.light" }} component="span">
                <strong>11x more likely</strong>
              </Box>{" "}
              to land a brand deals than other creators on Bento
            </Typography>
          </Box>
        </>
      }
      buttonText={
        <>
          starts at{" "}
          <Box sx={{ fontSize: 20 }} component="span">
            <strong>$21.66/month</strong>
          </Box>
        </>
      }
      fromRoutes={`${routes.pro}`}
      plan={Plans.PRO_YEARLY}
      notQualified={notQualified}
    />
  );
};

export default ProPlanSplashPage;
